import { connect } from 'react-redux';
import ChangePassword from './ChangePassword';
import { getTranslation } from "../../../reducers/common/localization";
import {fetchChangePassword, fetchUpdateEmail} from "../../../reducers/account/restoreAccount";
import {getUserEmail} from "../../../reducers/account/userData";
import {resetSubmitFormData} from "../../../reducers/common/submitForm";
import { getCurrentRole } from '../../../reducers/account/role';

const mapStateToProps = state => {
    return {
        translation: getTranslation(state),
        userEmail: getUserEmail(state),
        role: getCurrentRole(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onChangePassword: (data) => {
            dispatch(fetchChangePassword(data));
        },
        onChangeEmail: (email) => {
            dispatch(fetchUpdateEmail(email))
        },
        onUnmount: () => {
            dispatch(resetSubmitFormData());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);



// WEBPACK FOOTER //
// ./src/components/accountManagement/changePassword/ChangePassword.container.js